<mx-component-lib-section titleText="Badges">
  <div class="flex flex-row gap-x-20 items-end mt-4">
    <div class="flex flex-col gap-y-12">
      <div class="flex flex-row gap-x-14 ps-3">
        <span matBadge="1" class="mat-badge-transparent"></span>
        <span matBadge="2" class="mat-badge-error"></span>
      </div>

      <div class="flex flex-row gap-x-14 ps-3">
        <span matBadge="1" matBadgeSize="large" class="mat-badge-transparent"></span>
        <span matBadge="2" matBadgeSize="large" class="mat-badge-error"></span>
      </div>

      <div class="flex flex-row gap-x-8">
        <span matBadge="1" class="mat-badge-transparent">
          <mat-icon color="on-surface-variant" class="material-icons-outlined">mail</mat-icon>
        </span>
        <span matBadge="2" class="mat-badge-error">
          <mat-icon color="on-surface-variant" class="material-icons-outlined">mail</mat-icon>
        </span>
      </div>

      <div class="flex flex-row gap-x-8">
        <span matBadge="999" class="mat-badge-transparent" matBadgeOverlap="false">
          <mat-icon color="on-surface-variant" class="material-icons-outlined">mail</mat-icon>
        </span>
        <span matBadge="999" class="mat-badge-error" matBadgeOverlap="false">
          <mat-icon color="on-surface-variant" class="material-icons-outlined">mail</mat-icon>
        </span>
      </div>
    </div>

    <div class="flex flex-col text-title-small">
      <p>Background Colors:</p>
      <ol class="list-decimal list-inside ms-4">
        <li>transparent</li>
        <li>error</li>
      </ol>
    </div>
  </div>
</mx-component-lib-section>
